<template>
  <category-select :value="value" @input="handleChange" :has-error="hasError"></category-select>
</template>

<script>
import inputMixin from '@/modules/forms/components/inputs/inputMixin'
import CategorySelect from '@/components/products/categories/CategorySelect'

export default {
  mixins: [
    inputMixin
  ],
  components: {
    CategorySelect
  }
}
</script>
